import emailjs from 'emailjs-com';
import React from 'react';
import toast from 'react-hot-toast';
const Contact = () => {

    const handleForm = (event) => {
        event.preventDefault()
        emailjs.sendForm("service_fd5h9zh", 'template_c8t6w1j', event.target, '3LiwWYES1e0bZekfU').then(res => {
            if (res.status === 200) {
                toast('Thank you for contacting us.')
                event.target.reset()
            }
        })
    }
    return (
        <div className="contact_part">

            <hr />
            <div className="container contact">

                <br />
                <h2 id="con">Contact</h2>
                <div className="row">

                    <div className="col-lg-6">

                        <h4>Contact Info</h4>
                        <br />
                        <p>If you have any quary please contact with us. You can contact with us in office or phone or
                            email. We are all time available for you.</p>

                        <br />
                        <h4>Address</h4>
                        <p>Matikata Combined Complext, Dhaka Cantonment, Dhaka 1206</p>
                        <h4>Phone</h4>
                        <p className="contact-info"><a href="tel:+8801682412636">(+88) 01682412636</a></p>
                        <h4>Email</h4>
                        <p className="contact-info"><a href="mailto:asaduzzamansoumit@gmail.com">asaduzzamansoumit@gmail.com</a></p><br />

                    </div>
                    <div className="col-lg-6">
                        <form action="" onSubmit={handleForm}>

                            <span>
                                <div>
                                    <input type="text" placeholder="YOUR NAME"
                                        name='name' required />
                                    <input type="email" placeholder="YOUR EMAIL"
                                        name='user_email' required />
                                </div>
                            </span>
                            <textarea id="w3review" name="message" rows="4" cols="50" placeholder="YOUR MASSAGE"></textarea>

                            <br /><br />
                            <button type="submit" className="btn btn-primary btn-lg" >Submit</button>
                        </form>
                    </div>
                </div>
                <div className="col-md-3"></div>
            </div>
        </div>
    );
};

export default Contact;